module.exports = __webpack_public_path__ + "static/screen-web-vault-4adca0fcd07875289a59e5eb830ecde5.png";